import { TipoUsuarioEnum } from 'enums/tipoUsuario';
import { Colegios, Estudiantes } from 'generated/graphql';
import { IProfesorFullType } from 'interface/profesor/profesor';
import { EnumRoles } from 'rbac/tipoRolUsuario';

export interface AuthReduxState {
	hasuraKey: string;
	tipoUsuario: 'admin' | 'profesor' | 'coordinador' | 'estudiante' | 'monitor' | 'colegio' | 'noUser';
	uid: string;
	user_id: string;
	nombre?: string;
	displayName?: string;
	authorized: boolean;
}

export interface ReduxState {
	auth: AuthReduxState;
	profesor: { user: Partial<IProfesorFullType> };
	estudiante: { user: Partial<Estudiantes> };
	ui: boolean;
}

export interface ICurrentUser {
	hasuraKey: string;
	tipoUsuario: TipoUsuarioEnum;
	uid: string;
	user_id: string;
	nombre: string;
	displayName: string;
	authorized: boolean;
	permissions: any[];
	colegio: string;
	rol: EnumRoles;
	avatarPath: string | null;
	listaColegios?: Colegios[];
	a?: number;
	v?: number;
	l?: string[][];
	userKey?: string;
	pais?: string;
	apellido?: string;
}

export const selectCurrentUser = (state: any): ICurrentUser => {
	return state.auth || {};
};

export type UserTypeTypes = 'admin' | 'profesor' | 'student' | 'colegio' | 'monitor' | 'noUser';

export const selectUserType = (state: ReduxState): UserTypeTypes => {
	if (state.auth.tipoUsuario === 'profesor' || state.auth.tipoUsuario === 'coordinador') {
		return 'profesor';
	}
	if (state.auth.tipoUsuario === 'admin') {
		return 'admin';
	}
	if (state.auth.tipoUsuario === 'estudiante') {
		return 'student';
	}
	if (state.auth.tipoUsuario === 'colegio') {
		return 'colegio';
	}
	if (state.auth.tipoUsuario === 'monitor') {
		return 'monitor';
	}
	return 'noUser';
};
